import {state} from '../store/cart';

export const BasketCountBadge = {
    computed: {
        count: () => state.count,
        notEmpty: function () {
            return this.count > 0;
        },
    },
    render() {
        return (this.notEmpty) ? (
            <span class="header-buttons__button_cart_count shopbar-button-count-circle">
        {this.count}
      </span>
        ) : null;
    }
}
